import {GeofenceEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {GeofenceAction} from "./GeofenceActionMenu";
import {useGeofenceMutation} from "../../../hooks/useGeofenceMutation";

export type UseGeofenceActionProps = {}

export type UseGeofenceActionResult = {
  onGeofenceActionClick: (role: GeofenceEntity, action: GeofenceAction) => void;
}

export const useGeofenceAction = (props: UseGeofenceActionProps = {}): UseGeofenceActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deleteGeofence,
  } = useGeofenceMutation()

  const _onGeofenceActionClick = useCallback((geofence: GeofenceEntity, action: GeofenceAction) => {
    if (action === "EDIT") {
      navigate(`/geofences/form`, {state: {id: geofence.id}})
    } else if (action === "DELETE") {
      deleteGeofence(geofence.id, undefined)
    }
  }, [navigate, deleteGeofence])

  return {
    onGeofenceActionClick: _onGeofenceActionClick
  }
}
